import { calculateBMI } from "src/utils/calculateGoals";
import {
  getSessionState,
  updateSessionState,
} from "src/pageDefinitions/session";
import { useOnce } from "src/hooks/lifecycle";
import { getSurveyAnswers } from "src/hooks/survey/answers";

export type LandingPageBMIs = {
  currentBMI: number;
  targetBMI: number;
};

declare module "src/pageDefinitions/session" {
  interface BrowserSessionState {
    landingPageBMIs?: LandingPageBMIs;
  }
}

function setLandingPageBMIs(): LandingPageBMIs {
  const surveyAnswers = getSurveyAnswers();
  if (!surveyAnswers.heightCm) {
    return null;
  }
  const BMIs = calculateBMI(surveyAnswers, false);
  updateSessionState("browser", {
    landingPageBMIs: BMIs,
  });
  return BMIs;
}

export function getLandingPageBMIs({
  setIfMissing,
}: { setIfMissing?: boolean } = {}): LandingPageBMIs {
  const landingBMI = getSessionState("browser").landingPageBMIs;
  if (landingBMI || !setIfMissing) {
    return landingBMI;
  }
  return setLandingPageBMIs();
}

export function useSetLandingPageBMIs() {
  useOnce(() => {
    setLandingPageBMIs();
  });
}
